import { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import workspaceAPI from '../../services/workspaceAPI';
import { registerPushNotifications } from '../../services/pushNotificationService';
import './WorkspaceJoinPage.css';

const WorkspaceJoinPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [companyName, setCompanyName] = useState('');
  const [inviteCode, setInviteCode] = useState(searchParams.get('code') || '');
  const [email, setEmail] = useState(searchParams.get('email') || '');
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const code = searchParams.get('code');
    if (code) setInviteCode(code.toUpperCase());
    const em = searchParams.get('email');
    if (em) setEmail(em);
  }, [searchParams]);

  useEffect(() => {
    if (inviteCode.trim().length >= 6) {
      workspaceAPI.getInvitePreview(inviteCode.trim()).then((res) => setCompanyName(res.data.companyName || '')).catch(() => {});
    }
  }, [inviteCode]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password.length < 6) return setError('Password must be at least 6 characters');
    if (password !== confirmPassword) return setError('Passwords do not match');
    setLoading(true);
    try {
      const res = await workspaceAPI.join({
        inviteCode: inviteCode.trim(),
        email: email.trim(),
        password,
        name: name.trim(),
      });
      if (res.data.success && res.data.token) {
        localStorage.setItem('token', res.data.token);
        localStorage.setItem('user', JSON.stringify(res.data.user));
        window.dispatchEvent(new CustomEvent('codex-authenticated'));
        await registerPushNotifications().catch(() => {});
        navigate('/workspace', { replace: true });
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to join');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="workspace-join-page">
      <div className="workspace-join-card">
        <h1>Join Workspace</h1>
        {companyName && <p className="workspace-join-company">Joining <strong>{companyName}</strong></p>}
        <p className="workspace-join-hint">Use the invite from your company admin. Your email must be authorized first.</p>
        {error && <p className="workspace-join-error">{error}</p>}
        <form onSubmit={handleSubmit}>
          <label>Workspace code<input value={inviteCode} onChange={(e) => setInviteCode(e.target.value.toUpperCase())} maxLength={8} required /></label>
          <label>Work email<input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required /></label>
          <label>Your name<input value={name} onChange={(e) => setName(e.target.value)} required /></label>
          <label>Password<input type="password" value={password} onChange={(e) => setPassword(e.target.value)} minLength={6} required /></label>
          <label>Confirm password<input type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required /></label>
          <button type="submit" className="workspace-btn" disabled={loading}>{loading ? 'Joining...' : 'Join workspace'}</button>
        </form>
        <p className="workspace-join-footer">Have a password? <Link to="/login">Company login</Link></p>
      </div>
    </div>
  );
};

export default WorkspaceJoinPage;
